import React from "react";
import { Input } from "@chakra-ui/react";
import { FieldWrapper } from "../../components/form/FieldWrapper";
import { NullableSwitch } from "../../components/form/NullableSwitch";
import { useDisabled, useNAState, isEmptyValue } from "../../utils/formField";

type Props = {
  field: any;
  value?: any;
  readOnly?: any;
  invalid?: boolean;
  submitted?: boolean;
};

const TelephoneField: React.FC<Props> = ({
  field,
  value = "",
  readOnly,
  invalid,
  submitted = false,
}) => {
  const nullable = field?.nullable === true;

  const { mode, setMode, text, setText } = useNAState({ value, nullable });
  const { ro, disabled } = useDisabled({ readOnly, nullable, mode });

  const requiredNow = !nullable || mode === "val";
  const derivedInvalid = !!invalid || (submitted && requiredNow && isEmptyValue(text));

  return (
    <FieldWrapper field={field} invalid={derivedInvalid}>
      <NullableSwitch
        nullable={nullable}
        mode={mode}
        setMode={setMode}
        readOnly={ro}
      >
        <Input
          name={!ro && requiredNow ? field.name : undefined}
          type="tel"
          value={text}
          onChange={(e) => setText(e.target.value)}
          isDisabled={disabled}
          readOnly={ro}
          inputMode="tel"
          
          // TODO? pattern="^\+?[0-9\s\-\(\)\.]{3,}$"
          autoComplete="tel"
        />
      </NullableSwitch>

      {ro && (
        <input
          type="hidden"
          name={field.name}
          value={nullable ? (mode === "na" ? "N/A" : text) : text}
        />
      )}
      {!ro && nullable && mode === "na" && (
        <input type="hidden" name={field.name} value="N/A" />
      )}
    </FieldWrapper>
  );
};

export default TelephoneField;
